import { apiClient } from "../config";

async function changeObservationStatus(id: any, status: any) {
  const url = `/admin/observations/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default changeObservationStatus;
